module.exports = __webpack_public_path__ + "static/media/icon-security.1b1c221e.png";